import { useAuth } from './AuthContext'

/**
 * Check if the current user has a specific role
 * @param role - The role to check for
 * @returns true if the user has the specified role, false otherwise
 */
export function useHasRole(role: string): boolean {
  const { user } = useAuth()
  
  if (!user) {
    return false
  }
  
  return user.roles.includes(role)
}

/**
 * Check if the current user has any of the specified roles
 * @param roles - Array of roles to check for
 * @returns true if the user has at least one of the specified roles, false otherwise
 */
export function useHasAnyRole(roles: string[]): boolean {
  const { user } = useAuth()
  
  if (!user) {
    return false
  }
  
  return roles.some(role => user.roles.includes(role))
}

/**
 * Shorthand hook for checking if the current user is an admin
 * @returns true if the user has the 'admin' role, false otherwise
 */
export function useIsAdmin(): boolean {
  return useHasRole('admin')
}
